const BATTLE_FLAG_KEY = 'VITE_ENABLE_PHASE2_BATTLES';
const BATTLE_OVERRIDE_KEY = 'tension.feature.phase2Battles';

function asEnabled(value: unknown): boolean {
  if (typeof value !== 'string') return false;
  return ['1', 'true', 'yes', 'on'].includes(value.trim().toLowerCase());
}

export function isPhase2BattleEnabled(): boolean {
  const envValue = import.meta.env?.[BATTLE_FLAG_KEY];
  const envEnabled = asEnabled(envValue);
  if (typeof window === 'undefined') return envEnabled;
  try {
    const localOverride = window.localStorage.getItem(BATTLE_OVERRIDE_KEY);
    if (localOverride === 'off') return false;
    if (localOverride === 'on') return true;
  } catch {
    // localStorage can be unavailable in strict privacy contexts.
  }
  return envEnabled;
}

export function getPhase2BattleFlagKey(): string {
  return BATTLE_FLAG_KEY;
}

const QBR_WORKSPACE_FLAG_KEY = 'VITE_ENTERPRISE_QBR_WORKSPACE_EXCERPTS';
const QBR_WORKSPACE_OVERRIDE_KEY = 'tension.feature.enterpriseQbrWorkspaceExcerpts';

/** Wave 9 KV QBR notes on enterprise workspace home (client gate; Edge enforces org role). */
export function isEnterpriseQbrWorkspaceExcerptsEnabled(): boolean {
  const envValue = import.meta.env?.[QBR_WORKSPACE_FLAG_KEY];
  const envEnabled = asEnabled(envValue);
  if (typeof window === 'undefined') return envEnabled;
  try {
    const localOverride = window.localStorage.getItem(QBR_WORKSPACE_OVERRIDE_KEY);
    if (localOverride === 'off') return false;
    if (localOverride === 'on') return true;
  } catch {
    /* ignore */
  }
  return envEnabled;
}

export function getEnterpriseQbrWorkspaceExcerptsFlagKey(): string {
  return QBR_WORKSPACE_FLAG_KEY;
}
